import React from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  SkeletonPageFooter,
} from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/stock_log/table.config';

const ReportStockLogScreen = () => {
  const ReportStockLogTable = useTable('report_stock_log', tableConfig);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );
  const selectedWarehouse = useSelector((state) => state?.Auth?.selectedWarehouse);

  React.useEffect(() => {
    const filters = {
      warehouse_id: selectedWarehouse?.id,
    };

    ReportStockLogTable.boot(filters);
  }, []);


  return (
    <Page className="fixed">
      <Page.Header
        pretitle="Daftar"
        className="bg-white"
        title={'Laporan Item Stock Log'}
        isLoading={StateLoading}
      />

      <Page.Navigation toolbar>
        <ReportStockLogTable.Tools downloadable isLoading={StateLoading} />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className={cn(
            'col-md-12   m-0 p-0'
          )}
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <ReportStockLogTable.Render />
          )}
        </div>

      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <ReportStockLogTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default ReportStockLogScreen;
